<template>
    <span>
 <!--<UserSelectForWF-->
   <!--ref="WFTree"-->
   <!--:options="wfTreeOption"-->
   <!--@afterSelect="afterSelectUser"-->
 <!--&gt;</UserSelectForWF>-->
    <!--<el-select v-model="roleguid" placeholder="" style="width: 238px" v-if="btnpass&&!this.auditover" @change="changeRoles">-->
                  <!--<el-option-->
                    <!--v-for="item in roles"-->
                    <!--:key="item.uguid"-->
                    <!--:label="item.uname"-->
                    <!--:value="item.uguid">-->
                  <!--</el-option>-->
    <!--</el-select>-->
    <el-button type="warning" @click="Back" icon="el-icon-back" v-if="btnback" :loading="loading">退 回</el-button>
    <el-button type="danger" @click="Delete" icon="el-icon-delete" v-if="btndelete" :loading="loading">作 废</el-button><el-button type="primary" @click="Save" icon="el-icon-edit" v-if="btnsave" :loading="loading">暂 存</el-button>
    <el-button type="primary" @click="Pass" icon="el-icon-check" v-if="btnpass" :loading="loading">{{passname}}</el-button>
    <el-button type="warning" @click="Draw" icon="el-icon-refresh" v-if="btndraw" :loading="loading">撤 回</el-button>
    <el-button @click="closeDia" icon="el-icon-close">关 闭</el-button>
    </span>
</template>

<script>
  // import UserSelectForWF from "@/components/common/UserSelectForWF"; //引用工作流岗位人员选择对话框
  // import {changePost} from "../../../api/login"

    export default {
      name: "wfButton",
      data() {
        return {
          workflow: [],
          roles:[],
          roleguid:'',
          btndelete: false,
          btndraw: false,
          btnsave: false,
          btnpass: false,
          btnback: false,
          loading: false,
          selectuser:false,
          auditover:false,
          passname: '提 交',
        }
      },
      computed: {
      },
      methods: {
        changeRoles(){
          // changePost({roleguid:this.roleguid}).then(response => {
          //   if (response.data.code === 0) {
          //     localStorage.setItem("userInfoModel", JSON.stringify(response.data.obj));
          //    try{
          //
          //       this.$emit("afterchangeuser",response.data.obj)
          //    }catch(e){
          //        consol.log(e)
          //    }
          //
          //   }
          // });
        },
        InitAddButton(handleParam){
          if(handleParam==null){
            handleParam={allowsave:false,allowpass:true,allowback:false,allowdelete:false,allowdraw:false,auditover:false};
          }
          this.InitButton(handleParam);
          this.passname="提 交";
        },
        InitButton(handleParam){
          this.loading=false;
          this.workflow=handleParam;
          this.btnsave=handleParam.allowsave;
          this.btnpass=handleParam.allowpass;
          this.btnback=handleParam.allowback;
          this.btndelete=handleParam.allowdelete;
          this.btndraw=handleParam.allowdraw;
          this.auditover=handleParam.auditover;
          this.selectuser=handleParam.selectuser;
          if(this.btnpass&&this.btndelete){
            this.passname="提 交";
          }else
            this.passname="通 过";
          if(this.auditover)
            this.passname="办 结";
          if(this.btnpass&&!this.auditover&&handleParam.handleuguid&&handleParam.handleuguid!='') {
            // for (let i in this.roles) {
            //   if (this.roles[i].uguid == handleParam.handleuguid&&handleParam.handleuguid!=this.roleguid) {
            //     this.roleguid=this.roles[i].uguid;
            //     this.changeRoles();
            //   }
            // }
          }
          return this.btnpass;
        },
        Save(){
          this.loading=true;
          this.workflow.wfhandletype='save';
          this.$emit('saveWorkFlow',this.workflow);
        },
        Pass(){
          if(!this.auditover&&this.selectuser){//需要弹出选择人员的页面
            // this.$refs.WFTree.showdialog();
           // this.afterSelectUser('ef78d8c2-3c65-4675-ae0b-84a0b5ffc333;06a94b47-c4bb-488b-ada2-7f8620740052')
          }else{
            this.afterSelectUser('')
          }
        },
        afterSelectUser(users){//选择人员后执行
          this.loading=true;
          this.workflow.freedomset=users;
          this.workflow.wfhandletype='pass';
          this.$emit('saveWorkFlow',this.workflow);
        },
        Back(){
          this.$confirm('此操作将把流程退回给发起人, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading=true;
            this.workflow.wfhandletype='back';
            this.$emit('saveWorkFlow',this.workflow);
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        },
        Delete() {
          this.$confirm('此操作将删除流程所有信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            this.$emit('deleteWorkFlow');
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        },
        Draw(){
          this.loading=true;
          this.workflow.wfhandletype='draw';
          this.$emit('saveWorkFlow',this.workflow);
        },
        closeDia(){
          this.$emit('closeDialog');
        },
        showdisabledButton(){
          this.loading=false;
        }
      },
      computed:{
        // //人员选择树参数
        // wfTreeOption: function () {
        //   var userinfo = JSON.parse(localStorage.getItem("userInfoModel"));
        //   return {
        //     title: "后续审批流程配置",
        //     texts: "" ,
        //     ids: "",
        //     canSelectGroupTypeNode: false,
        //     useRight: true,
        //     menuguid: "", //菜单guid
        //     fdpath:userinfo.fdpath
        //   }
        // },
      },
      mounted() {
        var userinfo = JSON.parse(localStorage.getItem("userInfoModel"));
        // this.roles=userinfo.roles;
        // this.roleguid=userinfo.currentuguid;
      },
      components:{
        // UserSelectForWF//工作流人员岗位选择组件
      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/set/workflow/WorkflowButton.vue